import { render, staticRenderFns } from "./Peniasco.vue?vue&type=template&id=126bab0d"
import script from "./Peniasco.vue?vue&type=script&lang=js"
export * from "./Peniasco.vue?vue&type=script&lang=js"
import style0 from "./Peniasco.vue?vue&type=style&index=0&id=126bab0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports